'use client';

import type { AlgoliaDebugEntry } from '@/lib/algolia/debugLog.types';
import { devLog } from '@/lib/utils/devLog';
import { useEffect, useRef } from 'react';

interface AlgoliaDebugEchoProps {
  entries: AlgoliaDebugEntry[];
  context?: string;
}

/**
 * Replays server-collected Algolia debug entries in the browser console.
 * Algolia runs during SSR — without this, logs only appear in server/Vercel output.
 */
export function AlgoliaDebugEcho({ entries, context }: AlgoliaDebugEchoProps) {
  const loggedRef = useRef(false);

  useEffect(() => {
    if (loggedRef.current || entries.length === 0) return;

    loggedRef.current = true;

    devLog(
      `[Algolia] Server-side search trace${context ? ` (${context})` : ''} — echoed to browser:`,
      entries
    );

    for (const entry of entries) {
      devLog(`[Algolia] ${entry.operation} → ${entry.phase}`, entry.details);
    }
  }, [context, entries]);

  return null;
}
